import React, { Component } from 'react';
import {Subtopic, Footer, Button, PicHolder, TextHolder} from '../../Components/contentHolders/contentHolders.js';
import './styles.css';

import hippo from '../../Pictures/hippo.png';

export class ChapterHundredFourteen extends Component {

  render() {
    return (

      <section className="Content">
        <div className="content-holder">
        <div className="content-holder-inner fade">

        <Subtopic subtopicNumber={ this.props.number } subtopicTitle={ this.props.name } >

        {"" }
        </Subtopic>

        <PicHolder src={hippo} alt='Hippo Reads' picNote='' />




        <div className="block-outer block-outer-textholder">
          <div className="block-inner block-inner-textholder">

            <div className="text-holder">
              <p><a href="http://hipporeads.com/">Hippo Reads </a>is a media platform that sits at the compelling intersection of academic insights and real world issues. Their curations, written by top researchers in a range of disciplines, provide a link between recommended academic and journalistic “reads” and the most pressing questions of our time.</p>

            </div>
          </div>
        </div>

        <TextHolder text="" />


          <Button next={ this.props.next } buttonText= { this.props.buttonText } />
          <Footer />
          </div>
        </div>
      </section>

    );
  }
}



// WEBPACK FOOTER //
// ./src/Containers/Content/114.js